import React from "react";
import tw from "twin.macro";
import styled from 'styled-components';
import AnimationRevealPage from "./components/helpers/AnimationRevealPage.js";
import Hero from "./components/hero/TwoColumnWithInput.js";
import FeatureWithSteps from "./components/features/TwoColWithSteps.js";
import MainFeature2 from "./components/features/TwoColWithTwoHorizontalFeaturesAndButton.js";
import SliderCard from "./components/cards/ThreeColSlider.js";
import Footer from "./components/footers/MainFooterWithLinks";
import { useTranslation } from "react-i18next";

import Dev1 from "./images/img/Flashlight-cuate.svg";
import Dev2 from "./images/img/Delivery address-amico.svg";
import Dev3 from "./images/img/Messenger-rafiki.svg";
import Email from "./images/img/Rechlama.d67980d053c9b6436a64.svg"

import { ContentWithPaddingXl } from "./components/misc/Layouts.js";

import { ReactComponent as One } from "./images/icon/01.svg";
import { ReactComponent as Two } from "./images/icon/02.svg";
import { ReactComponent as Three } from "./images/icon/03.svg";
import { ReactComponent as For } from "./images/icon/04.svg";

const NewSectionContainer = styled.div`
    ${tw`flex flex-col lg:flex-row items-center max-w-screen-xl mx-auto py-20`}
    margin-bottom: 40px;
`;
const Navlink=styled.a`text-decoration: none
`
const TextColumn = styled.div`
    ${tw`lg:w-6/12 flex flex-col items-center lg:items-start`}
`;

const ImageColumn = styled.div`
    ${tw`lg:w-6/12 mt-10 lg:mt-0 flex justify-center`}
`;

const Heading = styled.h2`
    ${tw`mt-4 font-black text-left font-black   text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight `}
`;

const DeliveryHeading = styled.h2`
    ${tw`mt-4 font-black text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight ml-16`}
`;


const Paragraph = styled.p`
    ${tw` mt-4 text-base xl:text-xl my-2 lg:my-4 text-gray-700`}
    margin-bottom: 10px; /* Added margin bottom */
    line-height: 1.8; /* Adjusted line height for more space between lines */
`;

const Button = styled.button`
    ${tw`mt-8 px-8 py-3 text-white text-lg rounded-full transition duration-300`}
    background-color: #0ABD19;
    border: none;
    &:hover {
        background-color: #70D392;
    }
    &:focus {
        outline: none;
    }
`;

const Image = styled.img`
    ${tw`w-full mt-10 max-w-md rounded-lg`}
`;

const DeliveryMethodsContainer = styled.div`
    ${tw`flex flex-col items-center max-w-screen-xl mx-auto px-6 sm:px-8 lg:px-12 mt-12`}
`;


const CardsContainer = styled.div`
    ${tw`flex flex-col md:flex-row justify-center items-stretch gap-16 mt-10 flex-wrap`}
`;

const Card = styled.div`
    ${tw`flex flex-col items-center bg-white rounded-2xl  p-6 transition-transform duration-300 transform hover:scale-105`}
    width: 350px;
    min-height: 360px; /* фиксируем минимальную высоту */
    height: 100%;
    box-sizing: border-box;
    word-wrap: break-word;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
`;


const CardImage = styled.img`
    ${tw`w-[144px] h-[144px] mb-6`}  // 144px = 9rem
`;


const CardHeading = styled.h4`
    ${tw`text-2xl font-bold text-center mb-3`}
`;

const CardParagraph = styled.p`
    ${tw`text-gray-700 text-base text-center leading-relaxed`}
`;

const EmailSectionContainer = styled.div`
    ${tw`flex flex-col lg:flex-row items-center max-w-screen-xl mx-auto `}
    margin-top: 5%; /* Added margin top for spacing */
    
`;

const EmailTextColumn = styled.div`
    ${tw`flex flex-col lg:flex-row items-center max-w-screen-xl mx-auto py-20`}
    margin-bottom: 40px;
`;

const EmailImageColumn = styled.div`
    ${tw`lg:w-6/12 mt-10 lg:mt-0 flex justify-center`}
`;

const EmailMainParagraph = styled.p`
    ${tw`mt-4 text-3xl lg:text-2xl text-gray-700 text-center lg:text-left`}
    font-weight: bold;
    line-height: 1.8; /* Adjusted line height for more space between lines */
`;

const EmailSubParagraph = styled.p`
    ${tw`mt-4 text-base lg:text-lg text-gray-700 text-center lg:text-left`}
    line-height: 1.8; /* Adjusted line height for more space between lines */
`;

const EmailButton = styled.button`
    ${tw`mt-8 px-8 py-3 text-white text-lg rounded-full transition duration-300`}
    background-color: #0ABD19;
    border: none;
    &:hover {
        background-color: #70D392;
    }
    &:focus {
        outline: none;
    }
`;

const EmailImage = styled.img`
    ${tw`w-full max-w-md rounded-lg`}
`;

export default () => {
    const Subheading = tw.span`uppercase tracking-widest font-bold text-primary-500`;
    const HighlightedText = styled.span`
    ${tw`text-primary-500`} 
    color: #0ABD19; 
  `;
    const ContentWithPaddingXlCustom = styled(ContentWithPaddingXl)`
    ${tw`pb-5`} 
  `;
    const Steps = styled.span`
    ${tw`text-primary-500`} 
    color: #0ABD19; 
  `;
    const Prim = styled.span`
    ${tw`text-center text-primary-500 md:text-left`} 
    color: #0ABD19; 
  `;    const { t } = useTranslation();


    return (

        <AnimationRevealPage>
            <Hero roundedHeaderButton={true} />
            <FeatureWithSteps
                heading={
                    <>
                        {t("steps.howItWorks")} <HighlightedText>{t("steps.works")}</HighlightedText>
                    </>
                }
                textOnLeft={false}
                imageDecoratorBlob={true}
                decoratorBlobCss={tw`xl:w-40 xl:h-40 opacity-15 -translate-x-1/2 left-1/2`}
            />
            <DeliveryMethodsContainer>
                <DeliveryHeading>{t("delivery.title")}</DeliveryHeading>
                <CardsContainer>
                    <Card>
                        <CardImage src={Dev1} alt={t("delivery.toPickupAlt")} />
                        <CardHeading>{t("delivery.toPickup")}</CardHeading>
                        <CardParagraph>{t("delivery.toPickupDesc")}</CardParagraph>
                    </Card>
                    <Card>
                        <CardImage src={Dev2} alt={t("delivery.toLockerAlt")} />
                        <CardHeading>{t("delivery.toLocker")}</CardHeading>
                        <CardParagraph>{t("delivery.toLockerDesc")}</CardParagraph>
                    </Card>
                    <Card>
                        <CardImage src={Dev3} alt={t("delivery.toDoorAlt")} />
                        <CardHeading>{t("delivery.toDoor")}</CardHeading>
                        <CardParagraph>{t("delivery.toDoorDesc")}</CardParagraph>
                    </Card>
                </CardsContainer>
            </DeliveryMethodsContainer>

            <EmailSectionContainer>
                <TextColumn>
                    <Heading>
                        {t("email.register")} <HighlightedText>{t("email.usWarehouse")}</HighlightedText>
                    </Heading>
                    <Paragraph>{t("email.description")}</Paragraph>
                    <Navlink href="/RegistrationPage">
                        <Button>{t("email.getAddress")}</Button>
                    </Navlink>
                </TextColumn>
                <ImageColumn>
                    <Image src={Email} alt="Rechlama" />
                </ImageColumn>
            </EmailSectionContainer>
            <MainFeature2
                heading={
                    <>
                        {t("mainFeature.heading1")}<HighlightedText>{t("mainFeature.heading2")}</HighlightedText>
                    </>
                }
                showDecoratorBlob={false}
                features={[
                    {
                        Icon: One,
                        title: t("mainFeature.feature1.title"),
                        description: t("mainFeature.feature1.desc"),
                    },
                    {
                        Icon: Two,
                        title: t("mainFeature.feature2.title"),
                        description: t("mainFeature.feature2.desc"),
                    },
                    {
                        Icon: Three,
                        title: t("mainFeature.feature3.title"),
                        description: (
                            <>
                                {t("mainFeature.feature3.desc1")}<br />
                                {t("mainFeature.feature3.desc2")}
                            </>
                        )
                    },
                ]}
            />
            {/*<NewSectionContainer>*/}
            {/*    <TextColumn>*/}
            {/*        <Heading>Покупайте товары в США и Турции с большой выгодой</Heading>*/}
            {/*        <Paragraph>*/}
            {/*            Устали переплачивать за известные бренды? Благодаря высокой конкуренции на рынке в США и Турции, распродажа большинства товаров ощутимо дешевле, чем в России, а сэкономить на доставке поможет компания Eparcel.*/}
            {/*        </Paragraph>*/}
            {/*        <Navlink href="/RegistrationPage"> <Button>Получить адрес доставки</Button></Navlink>*/}
            {/*    </TextColumn>*/}
            {/*    <ImageColumn>*/}
            {/*        <Image src={Add} alt="Rechlama" />*/}
            {/*    </ImageColumn>*/}
            {/*</NewSectionContainer>*/}
            {/*<SliderCard/>*/}
            <Footer />
        </AnimationRevealPage>
    );
};
